import React from 'react'

import Empty from '~/components/Empty'

const NoChildAgesSelected = () => {
  return <Empty heading="No Learning Data" subheading="Choose a child age range to get started" />
}

export default NoChildAgesSelected
